var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.openCallCenter.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.$t('booking.callCenter'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }